import React, { Component } from 'react';
import './Steps.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class Step4 extends Component {
  constructor(props) {
    super(props);

    let optionsHeight = [];

    let maxHeight = 210
    if(props.fields.sex === 'F') {
      maxHeight = 190;
    }
    for(let i = 160; i <= maxHeight ; i += 1) {
      optionsHeight.push({
        value: i.toString(),
        label: `${i}cm`,
      });
    }

    this.state = {
      stepNumber: 4,
      fields: {
        height: '',
        bodyType: '',
        ethnicity: '',
      },
      optionsHeight,
    };
  }

  allFieldsFilled() {
    const emptyFields = Object.keys(this.state.fields).filter(field => (
      this.state.fields[field].length === 0
    ));
    return emptyFields.length === 0;
  }

  componentWillReceiveProps(newProps) {
    let maxHeight = 210
    if(newProps.fields.sex === 'F') {
      maxHeight = 190;
    }
    let optionsHeight = [];
    for(let i = 160; i <= maxHeight ; i += 1) {
      optionsHeight.push({
        value: i.toString(),
        label: `${i}cm`,
      });
    }

    this.setState({optionsHeight});
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;
    if(name === 'height') {
      fields[name] = e;
    } else {
      fields[name] = e.target.value;
    }

    this.setState({ fields });
  }

  handleNext(e) {
    e.preventDefault();
    this.props.saveData(this.state.fields);
    this.props.proceed(this.state.stepNumber);
  }

  render() {
    const fields = this.state.fields;
    return (
      <div className={`Step Step-container ${(this.props.active)?'active':''}`}>
        <div className="Step-title">
          What do you look like?
        </div>
        <ul className="steps">
          <li className="step-number done">1</li>
          <li className="step-number done">2</li>
          <li className="step-number done">3</li>
          <li className="step-number done">4</li>
          <li className="step-number">5</li>
          <li className="step-number">6</li>
        </ul>
        <div className="field-container select open">
          <div className="field-title">Your height:</div>
          <div className="row">
            <div className="col">
              <Select
                name="height"
                onChange={value => this.handleFieldChange(value.value, 'height')}
                options={this.state.optionsHeight}
                placeholder="Please select"
                value={fields.height}
                clearable={false}
              />
            </div>
          </div>
        </div>
        <div className="field-container radio open">
          <div className="field-title">Your bodytype:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="bodyTypeSlim" name="bodyType" value="slim" />
            <label className="col" htmlFor="bodyTypeSlim">Slim</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="bodyTypeAthletic" name="bodyType" value="athletic" />
            <label className="col" htmlFor="bodyTypeAthletic">Athletic</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="bodyTypeCurvy" name="bodyType" value="curvy" />
            <label className="col" htmlFor="bodyTypeCurvy">Curvy</label>
          </div>
        </div>
        <div className="field-container radio multi-line open">
          <div className="field-title">Ethnicity:</div>
          <div className="row">
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="ethnicity_african" name="ethnicity" value="african" />
            <label className="col col-md-4" htmlFor="ethnicity_african">African</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="ethnicity_asian" name="ethnicity" value="asian" />
            <label className="col col-md-4" htmlFor="ethnicity_asian">Asian</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="ethnicity_caucasian" name="ethnicity" value="caucasian" />
            <label className="col col-md-4" htmlFor="ethnicity_caucasian">Caucasian</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="ethnicity_middleEastern" name="ethnicity" value="middle_eastern" />
            <label className="col col-md-4" htmlFor="ethnicity_middleEastern">Middle Eastern</label>
            <input onChange={e => this.handleFieldChange(e, e.target.name)} type="radio" id="ethnicity_latin" name="ethnicity" value="latin" />
            <label className="col col-md-4" htmlFor="ethnicity_latin">Latin</label>
          </div>
        </div>
        <div className="row button-container space-between">
          <button
            className="btn btn-primary"
            onClick={(e) => {e.preventDefault();this.props.back(this.state.stepNumber);}}
          >
            Back
          </button>
          <button
            className="btn btn-primary"
            disabled={!this.allFieldsFilled()}
            onClick={(e) => this.handleNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Step4;


// WEBPACK FOOTER //
// ./src/components/Step4.js